import { duration } from "@mui/material";
import axiosInstance from "./axiosInstance";
const BASE_URL = process.env.REACT_APP_API_URL;

export const createSubscription = async (subscriptionPlanId, customer, user_id, start_at, userData) => {
    try {
       const response = await axiosInstance.post(`${BASE_URL}/razorpay/create-subscription`, {
            plan_id: subscriptionPlanId,
            customer,
            user_id,
            start_at,
            userData,
        });
        return response.data;
    } catch (error) {
        console.error("Error creating subscription:", error);
        throw error;
    }
};

export const getUserSubscription = async (userId) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/razorpay/my-subscription/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user subscription:", error);
    throw error;
  }
};

export const fetchSubscriptionPlans = async () => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/razorpay/public/subscription-plans`,
      { skipErrorToast: true }
    );

    const rawPlans = response.data?.plans || [];

    const formattedPlans = rawPlans.map(plan => {
      let features = [];

      try {
        features = JSON.parse(plan.description || "[]");
      } catch (error) {
        console.error("Invalid description:", plan.description);
      }

      return {
        id: plan.razorpay_plan_id,
        name: plan.name,
        price: Number(plan.amount),
        currency: plan.currency === "INR" ? "₹" : plan.currency,
        duration: plan.name,
        label: plan.name,
        durationType: plan.duration_type,
        durationValue: plan.duration_value,
        featuresLabel: "Features",
        features
      };
    });

    return formattedPlans;

  } catch (error) {
    console.error("Error fetching subscription plans:", error);
    throw error;
  }
};

export function evaluateSubscriptionAccess(data) {
  const sub = data?.subscription;
  const hasPendingAuth = data?.authenticatedExists;
  const now = Date.now();

  // 1️⃣ No subscription at all (new user)
  if (!sub) {
    return {
      access: hasPendingAuth ? 'pending' : 'subscribe',
      expiryRaw: null,
    };
  }

  const status = (sub.status ?? sub.subscription_status?.code ?? '').toLowerCase();
  const planName = sub.plan_name ?? sub.subscription_plan?.name;

  // 2️⃣ Active or completed → check expiry
  if (status === 'active' || status === 'completed') {
    if (sub.end_at) {
      const end = new Date(sub.end_at);
      const today = new Date();

      // Compare only date parts (local timezone)
      const isValid =
        end.getFullYear() > today.getFullYear() ||
        (end.getFullYear() === today.getFullYear() &&
          end.getMonth() > today.getMonth()) ||
        (end.getFullYear() === today.getFullYear() &&
          end.getMonth() === today.getMonth() &&
          end.getDate() >= today.getDate());
      if (isValid) {
        return {
          access: 'allow',
          expiryRaw: sub.end_at,
          planName,
        };
      }
    }

    // Active but expired
    return {
      access: 'expired',
      expiryRaw: sub.end_at ?? null,
      planName,
    };
  }

  // 3️⃣ Payment initiated but not completed
  if (hasPendingAuth) {
    return {
      access: 'pending',
      expiryRaw: null,
      planName,
    };
  }

  // 4️⃣ All other cases (expired, cancelled, etc.)
  return {
    access: 'expired',
    expiryRaw: sub.end_at ?? null,
    planName,
  };
}


export async function fetchSubscriptionAccess(userId) {
  const response = await axiosInstance.get(
    `${BASE_URL}/razorpay/subscription/${userId}`
  );
  return evaluateSubscriptionAccess(response.data);
}